import React from 'react';
import { formatPersianDate } from 'utils/formatPersianDate';
import { formatPersianNumber } from 'utils/formatPersianNumber';

const TransactionDetails = ({ amount, timestamp }) => {
  return (
    <div className="bg-white rounded-2xl shadow-xl p-6 md:p-8 space-y-3 md:space-y-4">
      <div className="flex justify-between items-center pb-3 md:pb-4 border-b border-red-100">
        <span className="text-sm md:text-base text-gray-500">مبلغ پرداختی</span>
        <span className="text-base md:text-lg lg:text-xl font-bold text-red-600">
          {formatPersianNumber(amount)} تومان
        </span>
      </div>

      <div className="flex justify-between items-center">
        <span className="text-sm md:text-base text-gray-500">تاریخ و زمان</span>
        <span className="text-sm md:text-base text-gray-800" dir="rtl">
          {formatPersianDate(timestamp)}
        </span>
      </div>
    </div>
  );
};

export default TransactionDetails;
